// extracted by mini-css-extract-plugin
export default {"selectedLanguage":"niuBg hRgdS"};